define('OutSystems/ClientRuntime/modules/ClientVariables/LocalStorageSerializer',["require", "exports", "../../DataTypes"], function (require, exports, DataTypes_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.deserialize = exports.serialize = void 0;
    var BOOLEAN_TRUE_SERIALIZED = "true";
    var BOOLEAN_FALSE_SERIALIZED = "false";
    function unsupportedTypeMessage(type) {
        return "Unsupported data type (" + type + ") for client variable";
    }
    function isValueMatchingType(value, type) {
        switch (type) {
            case DataTypes_1.DataTypes.Integer:
                return DataTypes_1.TypeValidations.isValidInteger(value);
            case DataTypes_1.DataTypes.LongInteger:
                return DataTypes_1.TypeValidations.isValidLongInteger(value);
            case DataTypes_1.DataTypes.Decimal:
            case DataTypes_1.DataTypes.Currency:
                return DataTypes_1.TypeValidations.isValidDecimal(value);
            case DataTypes_1.DataTypes.Boolean:
                return DataTypes_1.TypeValidations.isBoolean(value);
            case DataTypes_1.DataTypes.Text:
            case DataTypes_1.DataTypes.PhoneNumber:
            case DataTypes_1.DataTypes.Email:
                return DataTypes_1.TypeValidations.isText(value);
            case DataTypes_1.DataTypes.Date:
                return DataTypes_1.TypeValidations.isValidDate(value);
            case DataTypes_1.DataTypes.DateTime:
                return DataTypes_1.TypeValidations.isValidDateTime(value);
            case DataTypes_1.DataTypes.Time:
                return DataTypes_1.TypeValidations.isValidTime(value);
            default:
                var typeName = DataTypes_1.mapDataTypeToName(type);
                var formattedErrorMessage = unsupportedTypeMessage(typeName);
                throw new TypeError(formattedErrorMessage);
        }
    }
    function serialize(value, type) {
        if (value === undefined || value === null) {
            throw new TypeError("Value " + value + " is not a valid value for a client variable.");
        }
        if (!isValueMatchingType(value, type)) {
            var typeName = DataTypes_1.mapDataTypeToName(type);
            throw new TypeError("Value " + value + " is not a valid value for a client variable of the specified type (" + typeName + ").");
        }
        switch (type) {
            case DataTypes_1.DataTypes.Integer:
            case DataTypes_1.DataTypes.LongInteger:
            case DataTypes_1.DataTypes.Decimal:
            case DataTypes_1.DataTypes.Currency:
                return value.toString();
            case DataTypes_1.DataTypes.Boolean:
                return value ? BOOLEAN_TRUE_SERIALIZED : BOOLEAN_FALSE_SERIALIZED;
            case DataTypes_1.DataTypes.Text:
            case DataTypes_1.DataTypes.PhoneNumber:
            case DataTypes_1.DataTypes.Email:
                return value;
            case DataTypes_1.DataTypes.Date:
                return value.toISODate();
            case DataTypes_1.DataTypes.DateTime:
                return value.toString();
            case DataTypes_1.DataTypes.Time:
                return value.toISOTime();
            default:
                throw new TypeError(unsupportedTypeMessage("" + type));
        }
    }
    exports.serialize = serialize;
    function deserialize(value, type) {
        switch (type) {
            case DataTypes_1.DataTypes.Integer:
                var integer = Number(value);
                return !(DataTypes_1.TypeValidations.isValidInteger(integer) && DataTypes_1.TypeValidations.isWithinIntegerRange(integer))
                    ? DataTypes_1.Constants.DEFAULT_INTEGER
                    : integer;
            case DataTypes_1.DataTypes.LongInteger:
                if (!value) {
                    return DataTypes_1.Constants.DEFAULT_LONGINTEGER;
                }
                var longInteger = DataTypes_1.LongInteger.fromString(value);
                return !DataTypes_1.TypeValidations.isValidLongInteger(longInteger) ? DataTypes_1.Constants.DEFAULT_LONGINTEGER : longInteger;
            case DataTypes_1.DataTypes.Decimal:
                if (!value) {
                    return DataTypes_1.Constants.DEFAULT_DECIMAL;
                }
                var decimal = new DataTypes_1.Decimal(value);
                return !(DataTypes_1.TypeValidations.isValidDecimal(decimal) && DataTypes_1.TypeValidations.isWithinDecimalRange(decimal))
                    ? DataTypes_1.Constants.DEFAULT_DECIMAL
                    : decimal;
            case DataTypes_1.DataTypes.Currency:
                if (!value) {
                    return DataTypes_1.Constants.DEFAULT_CURRENCY;
                }
                var currency = new DataTypes_1.Decimal(value);
                return !(DataTypes_1.TypeValidations.isValidDecimal(currency) && DataTypes_1.TypeValidations.isWithinDecimalRange(currency))
                    ? DataTypes_1.Constants.DEFAULT_CURRENCY
                    : currency;
            case DataTypes_1.DataTypes.Boolean:
                if (value === BOOLEAN_TRUE_SERIALIZED) {
                    return true;
                }
                else if (value === BOOLEAN_FALSE_SERIALIZED) {
                    return false;
                }
                else {
                    return DataTypes_1.Constants.DEFAULT_BOOLEAN;
                }
            case DataTypes_1.DataTypes.Text:
                return !DataTypes_1.TypeValidations.isText(value) ? DataTypes_1.Constants.DEFAULT_TEXT : value;
            case DataTypes_1.DataTypes.PhoneNumber:
                return !DataTypes_1.TypeValidations.isText(value) ? DataTypes_1.Constants.DEFAULT_PHONENUMBER : value;
            case DataTypes_1.DataTypes.Email:
                return !DataTypes_1.TypeValidations.isText(value) ? DataTypes_1.Constants.DEFAULT_EMAIL : value;
            case DataTypes_1.DataTypes.Date:
                var date = DataTypes_1.DateTime.fromISODate(value);
                return !DataTypes_1.TypeValidations.isValidDate(date) ? DataTypes_1.Constants.DEFAULT_DATE : date;
            case DataTypes_1.DataTypes.DateTime:
                var dateTime = DataTypes_1.DateTime.fromISODateTime(value);
                return !DataTypes_1.TypeValidations.isValidDateTime(dateTime) ? DataTypes_1.Constants.DEFAULT_DATETIME : dateTime;
            case DataTypes_1.DataTypes.Time:
                var time = DataTypes_1.DateTime.fromISOTime(value);
                return !DataTypes_1.TypeValidations.isValidTime(time) ? DataTypes_1.Constants.DEFAULT_TIME : time;
            case DataTypes_1.DataTypes.Record:
                throw new TypeError(unsupportedTypeMessage("Record"));
            case DataTypes_1.DataTypes.RecordList:
                throw new TypeError(unsupportedTypeMessage("List"));
            case DataTypes_1.DataTypes.BinaryData:
                throw new TypeError(unsupportedTypeMessage("Binary Data"));
            case DataTypes_1.DataTypes.Object:
                throw new TypeError(unsupportedTypeMessage("Object"));
            default:
                throw new TypeError(unsupportedTypeMessage("Unknown: " + value));
        }
    }
    exports.deserialize = deserialize;
});
//# sourceMappingURL=LocalStorageSerializer.js.map;
